/**
 * Fecha um dropdown ao clicar fora ou apertar Escape (JOR4-7365).
 *
 * Os três dropdowns do menu superior — empresa/filial, usuário e notificações —
 * repetiam o mesmo efeito, e nenhum deles fechava com Escape, o que deixava
 * quem navega por teclado preso dentro do painel.
 */

import { useEffect, type RefObject } from "react";

export const usarFecharDropdown = (
    aberto: boolean,
    container: RefObject<HTMLElement>,
    fechar: () => void,
) => {
    useEffect(() => {
        if (!aberto) return;

        const aoClicarFora = (evento: MouseEvent) => {
            if (!container.current?.contains(evento.target as Node)) fechar();
        };

        const aoTeclar = (evento: KeyboardEvent) => {
            if (evento.key !== "Escape") return;
            fechar();
            // Devolve o foco ao gatilho: sem isto o Escape joga o usuário de
            // volta ao início da página.
            const gatilho = container.current?.querySelector("button");
            if (gatilho instanceof HTMLElement) gatilho.focus();
        };

        // Captura nos dois: telas do sistema param propagação, e o evento
        // poderia nunca chegar ao document na fase de bolha.
        document.addEventListener("click", aoClicarFora, true);
        document.addEventListener("keydown", aoTeclar, true);

        return () => {
            document.removeEventListener("click", aoClicarFora, true);
            document.removeEventListener("keydown", aoTeclar, true);
        };
    }, [aberto, container, fechar]);
};
